<form (keydown.enter)="$event.preventDefault()" (ngSubmit)="submit()">
<div id="requisitionForm" fxLayout="column" fxLayoutAlign="start center">
    <dx-load-panel
        shadingColor="rgba(0,0,0,0.4)"
        [(visible)]="isLoading"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="true"
        [closeOnOutsideClick]="false"
    >
    </dx-load-panel>
    <div class="content-block dx-card responsive-paddings ocl-top-container" style="width: 95vw">
        <dx-toolbar id="navigation-header" style="padding-right: 16px !important;">
            <dxi-item location="before">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxShow fxHide.xs>
                    <h3 class="padding-block margin-h3" *ngIf="!isPhone && requisitionCreateForm.get('id')?.value === null">New Requisition</h3>
                    <h3 class="padding-block margin-h3" *ngIf="!isPhone && requisitionCreateForm.get('id')?.value !== null">Edit Requisition: {{requisitionCreateForm.get('code')?.value}}</h3>
                    <span [innerHTML]="Status" style="padding-right: 16px !important;"></span>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxShow fxHide.gt-xs
                     style="margin-top: 5px">
                    <h5 class="padding-block" style="margin-top: 0; margin-bottom: 0" *ngIf="isPhone && requisitionCreateForm.get('id')?.value === null">New Requisition</h5>
                    <h5 class="padding-block" style="width: 160px; margin-top: 0; margin-bottom: 0" *ngIf="isPhone && requisitionCreateForm.get('id')?.value !== null">Edit Requisition: {{requisitionCreateForm.get('code')?.value}}</h5>
                    <span [innerHTML]="Status"></span>
                </div>
            </dxi-item>
            <dxi-item location="before" [visible]="!isPhone">
                <app-recent-requisitions></app-recent-requisitions>
            </dxi-item>
            <dxi-item location="after" [visible]="!isPhoneOrTablet">
                <dx-button-group
                    [items]="moreOptions"
                    stylingMode="outlined"
                    (onItemClick)="itemClick($event)">
                </dx-button-group>
            </dxi-item>
            <dxi-item location="after" [visible]="!isPhoneOrTablet && !isReadOnly">
                <dx-button style="display: none;"
                    #unsignBtn
                           *ngIf='requisitionId !== -1'
                    [text]="'Unsign'"
                    [disabled]="IsCancelled"
                    (click)="openSignatureDialog()"
                ></dx-button>
            </dxi-item>
            <dxi-item location="after" [visible]="!isPhoneOrTablet && !isReadOnly">
                <dx-button style="display: none;"
                     #signBtn [text]="'Sign'"
                           *ngIf='requisitionId !== -1 || !allowCreateRequisitionWithMissingSignature'
                     [disabled]="IsCancelled"
                     (click)="openSignatureDialog()">
                </dx-button>
            </dxi-item>
            <dxi-item location="after" fxShow fxHide.sm [visible]="!isPhoneOrTablet && !isReadOnly" [disabled]="IsNotEditable">
                <dx-button *ngIf="!isReadOnly"
                    [text]="'Save'"
                    (keyup.enter)="preventDefault($event)"
                           [hoverStateEnabled]="IsNotEditable"
                    [disabled]="IsNotEditable"
                           [hint]="SubmitHint"
                    (click)="submit()"
                ></dx-button>
            </dxi-item>
            <dxi-item location="after" fxShow fxHide.sm [visible]="!isPhoneOrTablet && !isReadOnly">
                <dx-button
                    [text]="'Cancel'"
                    [disabled]="!IsRequisitionCancelable || IsNotEditable"
                    (click)="openCancelRequisitionDialog()"
                ></dx-button>
            </dxi-item>
            <dxi-item location="after" fxShow fxHide.sm [visible]="!isPhoneOrTablet && !isReadOnly && role !== 'Physician'">
                <dx-button [text]="'Clear'" (click)="clear()"></dx-button>
            </dxi-item>
        </dx-toolbar>
        <app-patient-physician-header
            [signature]="requisitionCreateForm.get('signature')?.value"
            [patientControl]="convertToFormControl(requisitionCreateForm.get('patient'))"
            [physicianControl]="convertToFormControl(requisitionCreateForm.get('physician'))"
            (patientSelectionChanged)="patientSelectionChanged($event)"
            [disabled]="isReadOnly || role === 'Physician'"
        ></app-patient-physician-header>
    </div>

    <div class="content-block dx-card responsive-paddings ocl-bottom-container" style="width: 95vw">
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" style="height: 680px;" [ngStyle.lt-md]="{height: 'auto'}">
            <div fxFlex="50">
                <div class="ocl-container-with-padding" style="height: auto !important; padding-bottom: 0 !important;">
                    <app-loading-header>Requisition Details</app-loading-header>
                    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between" style="margin-top: 16px;">
                        <div fxFlex="30" fxFlex="100">
                            <div class="dx-field">
                                <div class="dx-field-label">Collection Date</div>
                                <div class="dx-field-value">
                                    <dx-date-box
                                        [formControl]="convertToFormControl(this.requisitionCreateForm.get('collectionDate'))"
                                        (onContentReady)="onCollectionDateReady($event)"
                                        type="datetime"
                                        [disabled]="isReadOnly"
                                        [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'">
                                        <dx-validator validationGroup="requisitionForm">
                                            <dxi-validation-rule type="required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-date-box>
                                </div>
                            </div>
                        </div>
                        <div fxFlex="30" fxFlex="100">
                        <div class="dx-field">
                            <div class="dx-field-label">Fasting <span class="ocl-required-indicator">*</span></div>
                            <div class="dx-field-value">
                                <dx-select-box
                                    [valueExpr]="'value'"
                                    [displayExpr]="'text'"
                                    [dataSource]="clinicalInfo"
                                    [disabled]="isReadOnly"
                                    [formControl]="convertToFormControl(requisitionCreateForm.get('fasting'))"
                                >
                                    <dx-validator validationGroup="requisitionForm">
                                        <dxi-validation-rule type="required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box>
                            </div>
                        </div>
                        </div>
                        <div fxFlex="30" fxFlex="100">
                        <div class="dx-field">
                            <div class="dx-field-label">Priority <span class="ocl-required-indicator">*</span></div>
                            <div class="dx-field-value">
                                <dx-select-box
                                    [dataSource]="priorities"
                                    [disabled]="isReadOnly"
                                    [formControl]="convertToFormControl(requisitionCreateForm.get('priority'))"
                                >
                                    <dx-validator validationGroup="requisitionForm">
                                        <dxi-validation-rule type="required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                    <app-test-picker
                        [allTestsInPicker]="showAllTestsInPicker"
                        [pickerDataSource]="testPickerDataSource"
                        [testControl]="convertToFormControl(requisitionCreateForm.get('tests'))"
                        [disabled]="!IsPatientSelected || isReadOnly"
                    ></app-test-picker>
            </div>
            <div fxFlex="50" style="height: 100%">
                <div style="height: 240px;">
                    <app-bill-to
                        [patient]="requisitionCreateForm.get('patient')?.value"
                        [disabled]="!IsPatientSelected || isReadOnly"
                        [selectedBillingInfo]="selectedBillToOnlyForEdit"
                        [defaultBillTo]="selectedDefaultBillToOnlyForEdit"
                        [isEdit]="requisitionCreateForm.get('id')?.value !== undefined && requisitionCreateForm.get('id')?.value !== null"
                        (billToChanged)="billToChanged($event)"
                        (billingInfoChanged)="billingInfoChanged($event)"
                    ></app-bill-to>
                </div>
                <div style="height: 440px;">
                    <app-form-relation-glass
                      [maxHeight]="440"
                      [controlName]="'medications'"
                        [textSelectorPlaceholder]="'Code'"
                        [textSelectorExpr]="'code'"
                        [label]="'Medications'"
                        [disabled]="isLoading"
                        [dataSource]="medicationsDataSource.value"
                        [searchEnabled]="true"
                        [searchService]="medicationService"
                        [keyExpr]="'id'"
                        [optionalConfig]="{
                            button: {
                                text: 'Patient Medications',
                                icon: 'user',
                                disabled: !IsPatientSelected || isReadOnly,
                                filterExpr: undefined
                            }
                        }"
                        [columns]="medicationsFormRelationColumns"
                        [alternateDataSource]="alternateMedicationsDataSource.value"
                        [control]="convertToFormControl(requisitionCreateForm.get('medications'))"
                    ></app-form-relation-glass>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" style="height: 240px;" [ngStyle.lt-md]="{height: 'auto'}">
            <div fxFlex="25" style="height: 240px;" [ngStyle.xs]="{height: '360px !important'}">
                <app-comments-control
                    [label]="'Additional DX and Tests'"
                    [simpleMode]="true"
                    [valueChange]="true"
                    [control]="convertToFormControl(requisitionCreateForm.get('additionalTestsDxCodes'))"
                    [disabled]="!IsPatientSelected || isReadOnly"
                ></app-comments-control>
            </div>
            <div fxFlex="25" style="height: 240px;" [ngStyle.xs]="{height: '360px !important'}">
                <app-additional-copies [maxHeight]="240" [additionalCopiesControl]="convertToFormControl(requisitionCreateForm.get('additionalCopies'))"></app-additional-copies>
            </div>
            <div fxFlex="50" style="height: 240px;">
                <app-form-relation-glass
                  [controlName]="'diagnoses'"
                  [maxHeight]="240"
                    [textSelectorPlaceholder]="'Code'"
                    [textSelectorExpr]="'code'"
                    [label]="'Diagnoses'"
                    [disabled]="isLoading"
                    [dataSource]="diagnosisDataSource.value"
                    [searchEnabled]="true"
                    [searchService]="diagnosisService"
                    [keyExpr]="'id'"
                    [optionalConfig]="{
                            button: {
                                text: 'Patient Diagnoses',
                                icon: 'user',
                                disabled: !IsPatientSelected || isReadOnly,
                                filterExpr: undefined
                            }
                        }"
                    [columns]="diagnosesFormRelationColumns"
                    [alternateDataSource]="alternateDiagnosisDataSource.value"
                    [control]="convertToFormControl(requisitionCreateForm.get('diagnosisCodes'))"
                ></app-form-relation-glass>
            </div>
        </div>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" style="height: 240px;" [ngStyle.lt-md]="{height: 'auto'}">
            <div fxFlex="70" style="height: 240px;" [ngStyle.xs]="{height: '360px'}">
                <app-comments-control
                    [label]="'Requisition Comments'"
                    [valueChange]="true"
                    [disabled]="!IsPatientSelected || isReadOnly"
                    [control]="convertToFormControl(requisitionCreateForm.get('comments'))"
                ></app-comments-control>
            </div>
            <div fxFlex="30" style="height: 240px;">
                <div class="ocl-container-with-padding" style="width: 100%;">
                    <div>
                        <div fxLayout="row" fxLayoutAlign="space-between end">
                            <h4>Requisition Documents</h4>
                            <input type="file" (change)="onFileChanged($event)" style="display: none" #fileInput/>
                            <dx-button [disabled]="isUploading || requisitionCreateForm.get('id')?.value === undefined || requisitionCreateForm.get('id')?.value === null || isReadOnly"
                                       icon="fa fa-upload"  text="Upload" (click)="fileInput.click()" style="max-height: 26px; margin-bottom: 4px"></dx-button>
                        </div>
                    </div>
                    <div class="dx-card" fxLayout="row" fxLayoutAlign="space-between" style="height: 80%; ">
                        <dx-list [items]="docs" height="100%" width="100%"
                                 [disabled]="requisitionCreateForm.get('id')?.value === undefined || requisitionCreateForm.get('id')?.value === null">
                            <div *dxTemplate="let document of 'item'">
                                <div fxLayout="row" fxLayoutAlign="space-between">
                                    <div style='display: inline-flex; width: 100%'>
                                      {{document.name}}
                                      <span style='flex: 1'></span>
                                      <div>
                                        <dx-button icon='fas fa-eye' hint='View' (onClick)='documentClick(document.name)'></dx-button>
                                        <dx-button icon='fas fa-trash' hint='Remove' (onClick)='documentRemove(document.id)' style='margin-left: 4px'></dx-button>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </dx-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-signature-dialog
    [popupVisible]="electronicSignaturePopupVisible"
    (closeEvent)="signDialogClosed($event)"
></app-signature-dialog>
<app-signature-unsing-dialog
    [popupVisible]="electronicSignatureUnsignPopupVisible"
    (closeEvent)="unsignDialogClosed($event)"
></app-signature-unsing-dialog>
<app-cancel-dialog [popupVisible]="cancelPopupVisible" (closeEvent)="cancelRequisitionDialogClosed($event)"></app-cancel-dialog>
<app-printer-dialog
    [popupVisible]="printerDialogVisible"
    (closeEvent)="printerDialogVisible = false"
    [requisitionId]="this.requisitionCreateForm.get('id')?.value"
></app-printer-dialog>
</form>
<app-requisition-done-dialog [mode]="mode" [popupVisible]="requisitionDoneVisible" [requisitionId]="requisitionCreateForm.get('id')?.value"></app-requisition-done-dialog>

<dx-speed-dial-action
    icon="fa fa-barcode"
    label="Print Requisition Labels"
    [visible]="isPhoneOrTablet && IsRequisitionCancelable"
    [index]="1"
    (onClick)="openLabelPrinter()"
    (onContentReady)="onButtonReady($event)">
</dx-speed-dial-action>
<dx-speed-dial-action
    icon="fa fa-print"
    label="Print Requisition"
    [visible]="isPhoneOrTablet && IsRequisitionCancelable"
    [index]="2"
    (onClick)="printRequisition()"
    (onContentReady)="onButtonReady($event)">
</dx-speed-dial-action>
<dx-speed-dial-action
    icon="fa fa-pen-alt"
    [label]="requisitionCreateForm.get('signature')?.value !== null ? 'Sign Requisition' : 'Unsign Requisition'"
    [visible]="isPhoneOrTablet && IsRequisitionCancelable && !isReadOnly"
    [index]="3"
    (onClick)="openSignatureDialog()"
    (onContentReady)="onButtonReady($event)">
</dx-speed-dial-action>
<dx-speed-dial-action
    icon="save"
    label="Save"
    [visible]="isPhoneOrTablet && !IsNotEditable && !isReadOnly"
    [index]="4"
    (onClick)="submit()"
    (onContentReady)="onButtonReady($event)">
</dx-speed-dial-action>
<dx-speed-dial-action
    icon="clear"
    label="Cancel"
    [visible]="isPhoneOrTablet && IsRequisitionCancelable && !IsNotEditable && !isReadOnly"
    [index]="5"
    (onClick)="openCancelRequisitionDialog()"
    (onContentReady)="onButtonReady($event)">
</dx-speed-dial-action>
<dx-speed-dial-action
    icon="fa fa-history"
    label="Clear"
    [visible]="isPhoneOrTablet && !isReadOnly"
    [index]="6"
    (onClick)="clear()"
    (onContentReady)="onButtonReady($event)">
</dx-speed-dial-action>


